import { useMemo } from 'react';

import { ApplianceModel, FilterOption } from '@common/models';
import {
    filterAllEntries,
    getSelectedFiltersMap,
    initializeFiltersOptions,
} from '@core/components/filters/filterUtils';
import { useAppSelector } from '@redux/hooks';
import { FaucetFilters, selectFaucetFilters } from '@redux/slices/faucetSlice';

import useFaucet from './useFaucets';

type useFilteredFaucetsReturn = {
    filteredFaucets: ApplianceModel[];
    faucetFilters: FaucetFilters;
};

// TODO: consolidte with useFilteredSinks
const useFilteredFaucets = (): useFilteredFaucetsReturn => {
    const { browsedFaucets } = useFaucet();
    const _faucetFilters = useAppSelector(selectFaucetFilters);

    const initialFilterOptions: FaucetFilters = useMemo(() => {
        let initialFilters: FaucetFilters = {};
        const setFaucetFilters = (val: FaucetFilters) => {
            initialFilters = val;
        };
        if (browsedFaucets.length > 0) {
            initializeFiltersOptions(browsedFaucets, setFaucetFilters);
        }
        return initialFilters;
    }, [browsedFaucets]);

    const faucetFilters = useMemo(() => {
        return _faucetFilters ?? initialFilterOptions;
    }, [_faucetFilters, initialFilterOptions]);

    const filteredFaucets = useMemo(() => {
        const selectedFilters: Map<string, FilterOption[]> = getSelectedFiltersMap(faucetFilters);
        return filterAllEntries(Array.from(selectedFilters.entries()), browsedFaucets);
    }, [faucetFilters, browsedFaucets]);

    return {
        filteredFaucets,
        faucetFilters,
    };
};

export default useFilteredFaucets;
